<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>我的档案</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="font_right">
            <!--   -->
            <el-col :class="sysUser.Status==1?'hidden':''" :span="24">
                <div >                    
                    <el-button @click="CompleteInfo" type="primary" size="mini" round>补全信息</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row class="font_left">
            <el-col :span="5">
                <div>
                    <img class="img_size_50" :src="sysUser.HeadImg"/>
                </div>
            </el-col>
            <el-col :span="19">
                <div style="margin-left:20px;">
                    <div>
                        <span class="div_name">{{sysUser.TrueName}}</span>
                    </div>
                    <div class="mar_top_20">
                        <span class="mar_left_10">{{userBase.Gender==0?'女':'男'}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{userBase.Nature}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{userBase.Politcal}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{(userBase.BirthDay||'').split(' ')[0]}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.Region}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{userBase.IDNum}}</span>
                    </div>
                    <div class="mar_top_20">
                        <span class="mar_left_10">{{sysUser.UserCode}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.Phone}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.UserName}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{userBase.WorkPlace}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{userBase.RecruitIncome}}</span>
                    </div>
                    <div class="mar_top_20">
                        <span class="mar_left_10">{{sysUser.CompanyName}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.CenterName}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.GroupName}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.MainDeptsName}}{{sysUser.OtherDeptsNames==null?sysUser.OtherDeptsNames:(sysUser.OtherDeptsNames==''?sysUser.OtherDeptsNames:'/'+sysUser.OtherDeptsNames)}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.PositionName}}</span>
                        <span class="mar_left_10">|</span>
                        <span class="mar_left_10">{{sysUser.Duty}}</span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>身份证图片</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>
                    <span style="float:left;">身份证(人像面)：</span>
                    <el-image v-for="(img,index) in userBase.IDCardAttachPositive" :key="index" :src="img" style="width:300px;" :preview-src-list="userBase.IDCardAttachPositive" >
                    </el-image>
                    <!-- <el-popover placement="top-start" popper-class="myPopover" trigger="click">
                        <a :href="userBase.IDCardAttachPositive" target="_blank" title="查看最大化图片">
                            <img :src="userBase.IDCardAttachPositive" class="img_size_50" >
                        </a>
                        <img slot="reference" :src="userBase.IDCardAttachPositive" class="img_size_50" style="cursor:pointer">
                    </el-popover>    -->
                    <!-- <img class="img_size_50" :src="userBase.IDCardAttachPositive"/> -->
                </div>
            </el-col>
            <el-col :span="8">
                <div>
                    <span style="float:left;">身份证(国徽面)：</span>
                    <el-image v-for="(img,index) in userBase.IDCardAttachOppsite" :key="index" :src="img" style="width:300px;" :preview-src-list="userBase.IDCardAttachOppsite" >
                    </el-image>
                    <!-- <el-popover placement="top-start" popper-class="myPopover" trigger="click">
                        <a :href="userBase.IDCardAttachOppsite" target="_blank" title="查看最大化图片">
                            <img :src="userBase.IDCardAttachOppsite" class="img_size_50" >
                        </a>
                        <img slot="reference" :src="userBase.IDCardAttachOppsite" class="img_size_50" style="cursor:pointer">
                    </el-popover>    -->
                    <!-- <img class="img_size_50" :src="userBase.IDCardAttachOppsite"/> -->
                </div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>联系信息</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>公司手机号：{{userContact.CompanyPhone}}</div>
                <div class="mar_top_10">籍贯：{{userContact.NativePlace}}</div>
            </el-col>
            <el-col :span="8">
                <div>个人手机号：{{userContact.PersonalPhone}}</div>
                <div class="mar_top_10">户籍类型：{{userContact.ResidenceType}}</div>
            </el-col>
            <el-col :span="8">
                <div>现住址：{{userContact.NowAddress}}</div>
                <div class="mar_top_10">户籍地址：{{userContact.Address}}</div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>合同信息</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>用工类型：{{userContract.ContractType}}</div>
            </el-col>
            <el-col :span="8">
                <div>合同开始时间：{{(userContract.ContractBegin||'').split(' ')[0]}}</div>
            </el-col>
            <el-col :span="8">
                <div>合同结束时间：{{(userContract.ContractEnd||'').split(' ')[0]}}</div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>紧急联系人</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>关系：{{userEmergency.LinkType}}</div>
            </el-col>
            <el-col :span="8">
                <div>姓名：{{userEmergency.LinkName}}</div>
            </el-col>
            <el-col :span="8">
                <div>电话：{{userEmergency.LinkPhone}}</div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>教育信息</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>最高学历：{{userEducation.HighestEducation}}</div>
                <div class="mar_top_10">专业：{{userEducation.Subject}}</div>
            </el-col>
            <el-col :span="8">
                <div>毕业时间：{{(userEducation.GraduateDate||'').split(' ')[0]}}</div>
            </el-col>
            <el-col :span="8">
                <div>毕业院校：{{userEducation.GraduateSchool}}</div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left mar_top_10">
            <el-col :span="8">
                <div>
                    <span style="float:left;">学历证书：</span>
                    <img class="img_size_50" :src="userEducation.EducationAttach"/>
                </div>
            </el-col>
            <el-col :span="8">
                <div>
                    <span style="float:left;">学位证书：</span>
                    <img class="img_size_50" :src="userEducation.DegreeAttach"/>
                </div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>家庭信息</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>婚姻情况：{{userFamily.MarriageStatus?'已婚':'未婚'}}</div>
                <div class="mar_top_10">结婚纪念日：{{(userFamily.MarriageDay||'').split(' ')[0]}}</div>
                <div class="mar_top_10">子女出生日：{{(userFamily.ChildBirthday||'').split(' ')[0]}}</div>
            </el-col>
            <el-col :span="8">
                <div>产假开始时间：{{(userFamily.MaternityLeaveBegin||'').split(' ')[0]}}</div>
                <div class="mar_top_10">有无子女：{{userFamily.IsHaveChild?'有':'无'}}</div>
                <div class="mar_top_10"></div>
            </el-col>
            <el-col :span="8">
                <div>产假结束时间：{{(userFamily.MaternityLeaveEnd||'').split(' ')[0]}}</div>
                <div class="mar_top_10">子女性别：{{userFamily.IsHaveChild?(userFamily.ChildGender==1?'男':'女'):'无' }}</div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>资质信息</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="8">
                <div>资质名称：{{userQualification.QualificationName}}</div>
                <div class="mar_top_10">
                    <span style="float:left;">资质证书：</span>
                    <img class="img_size_50" :src="userQualification.QualificationAttach"/>
                </div>
            </el-col>
            <el-col :span="8">
                <div>资质获得时间：{{(userQualification.QualificationDate||'').split(' ')[0]}}</div>
            </el-col>
        </el-row>
        <div class="border_bottom"></div>
        <el-row style="font-size:12px;" class="font_left">
            <el-col :span="24">
                <div >
                    <h1>工作经历</h1>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-bottom:20px;font-size:12px;" v-for="item in userWorkHistory" :key="item.ID" class="font_left">
            <el-col :span="8">
                <div>公司名称：{{item.CompanyName}}</div>
                <div class="mar_top_10">所任职务：{{item.Position}}</div>
                <div class="mar_top_10">离职原因：{{item.LeaveReason}}</div>
            </el-col>
            <el-col :span="8">
                <div>公司性质：{{item.CompanyType}}</div>
                <div class="mar_top_10">开始时间：{{(item.BeginDate||'').split(' ')[0]}}</div>
                <div class="mar_top_10">同事电话：{{item.WorkmatePhone}}</div>
            </el-col>
            <el-col :span="8">
                <div>公司规模：{{item.Size}}</div>
                <div class="mar_top_10">结束时间：{{(item.EndDate||'').split(' ')[0]}}</div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
    import { GetSingeleUser,GeteUserBaseList,GetUserContactList,GetUserContractList,GetUseEducationList,GetUseEmergencyList,GetUseFamilyList,GetUseQualificationList,GetUseWorkHistoryList } from "../../until/ZeusApiSDK/Logic/StructureLogic";  
    export default {
        data() {
          return {
              currentUser:{},//当前登录用户信息
              sysUser:{},//用户基本信息
              userBase:{},//用户基本信息
              userContact:{},//用户联系信息
              userContract:{},//用户合同信息
              userEducation:{},//用户教育信息
              userEmergency:{},//紧急联系人信息
              userFamily:{},//家庭信息
              userQualification:{},//资质信息
              userWorkHistory:[],//工作经历
          }
        },
        methods: {
            //获取当前用户
            getCurrentUser:function(){
                var userinfo = window.sessionStorage.getItem("userinfo");
                userinfo = JSON.parse(Decrypt(userinfo));
                this.currentUser = userinfo;
            },
            //获取当前用户信息
            getUserInfo:function(){
                var userId=this.currentUser.UserId;
                //获取sysuser基本信息
                GetSingeleUser(userId,'RzqZeusStructureGetFullUser').then(res=>{
                    this.sysUser=res;
                    if(this.sysUser.HeadImg!=null&&this.sysUser.HeadImg.indexOf('https') !=-1){
                        //存在字符串
                        this.sysUser.HeadImg=this.sysUser.HeadImg.replace("https","http");
                    }
                });
                //构造参数
                var predicates=[{
                    Field:"UserID", 
                    Value:userId, 
                    Oper:"eq", 
                    IsAnd:1
                }];
                //获取userBase基本信息
                GeteUserBaseList(predicates).then(res=>{
                    if(res.length>0){
                        this.userBase=res[0];
                        var reg = new RegExp("https","g");//g,表示全部替换。
                        if(this.userBase.IDCardAttachPositive!=null&& this.userBase.IDCardAttachPositive.indexOf('https') !=-1){
                            //存在字符串
                            this.userBase.IDCardAttachPositive.replace(reg,"http");
                            this.userBase.IDCardAttachPositive=this.userBase.IDCardAttachPositive.replace("https","http");
                        }
                        if(this.userBase.IDCardAttachOppsite!=null&&this.userBase.IDCardAttachOppsite.indexOf('https') !=-1){
                            this.userBase.IDCardAttachOppsite.replace(reg,"http");
                            this.userBase.IDCardAttachOppsite=this.userBase.IDCardAttachOppsite.replace("https","http");
                        }
                        this.userBase.IDCardAttachPositive=[this.userBase.IDCardAttachPositive];
                        this.userBase.IDCardAttachOppsite=[this.userBase.IDCardAttachOppsite];
                        this.userBase.IDCardAttachPositive=[this.userBase.IDCardAttachPositive];
                        this.userBase.IDCardAttachOppsite=[this.userBase.IDCardAttachOppsite];
                    }
                });
                //获取userContact用户联系基本信息
                GetUserContactList(predicates).then(res=>{
                    if(res.length>0){
                        this.userContact=res[0];
                    }
                });
                //获取userContract用户合同信息
                GetUserContractList(predicates).then(res=>{
                    if(res.length>0){
                        this.userContract=res[0];
                    }
                });
                //获取userEducation教育信息
                GetUseEducationList(predicates).then(res=>{
                    if(res.length>0){
                        this.userEducation=res[0];
                        if(this.userEducation.EducationAttach!=null&& this.userEducation.EducationAttach.indexOf('https') !=-1){
                            //存在字符串
                            this.userEducation.EducationAttach=this.userEducation.EducationAttach.replace("https","http");
                        }
                        if(this.userEducation.DegreeAttach!=null&& this.userEducation.DegreeAttach.indexOf('https') !=-1){
                            //存在字符串
                            this.userEducation.DegreeAttach=this.userEducation.DegreeAttach.replace("https","http");
                        }
                    }
                });
                //获取userEmergency紧急联系人信息
                GetUseEmergencyList(predicates).then(res=>{
                    if(res.length>0){
                        this.userEmergency=res[0];
                    }
                });
                //获取userFamily家庭信息
                GetUseFamilyList(predicates).then(res=>{
                    if(res.length>0){
                        this.userFamily=res[0];
                    }
                });
                //获取userQualification资质信息
                GetUseQualificationList(predicates).then(res=>{
                    if(res.length>0){
                        this.userQualification=res[0];
                        if(this.userQualification.QualificationAttach!=null&& this.userQualification.QualificationAttach.indexOf('https') !=-1){
                            //存在字符串
                            this.userQualification.QualificationAttach=this.userQualification.QualificationAttach.replace("https","http");
                        }
                    }
                });
                //获取userWorkHistory工作经历信息
                GetUseWorkHistoryList(predicates).then(res=>{
                    this.userWorkHistory=res;
                });
            },
            //补全信息
            CompleteInfo:function(){
                this.$router.push('/Structure/EditUserFile?UserID='+this.currentUser.UserId+'&IsMyFile=1');
            }
        },
        //页面进入加载事件
        created:function(){
            //获取当前用户
            this.getCurrentUser();
            //获取当前用户信息
            this.getUserInfo();
        },
    }
</script>
<style lang="less" scoped>
.font_left{
    text-align:left;
}
.font_right{
    text-align:right;
}
.img_size{
    width:100%;
    // padding:20px;
}
.img_size_50{
    width:50%;
    // padding:20px;
}
.div_name{
    font-size:30px;
    margin-right:30px;
}
.mar_top_10{
    margin-top:10px;
}
.mar_top_20{
    margin-top:20px;
}
.mar_left_10{
    margin-right:10px;
}
.border_bottom{
    margin-top:26px;
    border-bottom: 1px dotted #d9d9d9;
}
.el-popover.myPopover{
    text-align: center;
    width:60%;
    // height:100%;
    background-color: #dcdcdc;
    // opacity:0.2;
}
.hidden{
    display:none;
}
</style>